import { c as _c } from "react/compiler-runtime";
import { formatCurrency } from "@/lib/format-data";
import { FeeStructure, formatDisplayPrice } from "@/lib/service-fees";
import { cx } from "@/lib/tailwind-utils";
export type PromotionPricing = FeeStructure & {
  originalDisplayPrice?: number | null;
  originalDisplayPriceMax?: number | null;
  promotionName?: string | null;
};
interface PromotionPriceDisplayProps {
  pricing: PromotionPricing;
  className?: string;
  originalClassName?: string;
  currentClassName?: string;
}
export const PromotionPriceDisplay = t0 => {
  const $ = _c(18);
  const {
    pricing,
    className,
    originalClassName,
    currentClassName
  } = t0;
  const hasPromotion = !!pricing.promotionName && !!pricing.originalDisplayPrice;
  let t1;
  if ($[0] !== className) {
    t1 = cx("inline-flex items-baseline gap-1.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hasPromotion || $[3] !== originalClassName || $[4] !== pricing) {
    t2 = hasPromotion && <span className={cx("text-foreground-muted line-through", originalClassName)}>{formatDisplayPrice({
        ...pricing,
        displayPrice: pricing.originalDisplayPrice ?? undefined,
        displayPriceMax: pricing.originalDisplayPriceMax ?? undefined
      }, formatCurrency)}</span>;
    $[2] = hasPromotion;
    $[3] = originalClassName;
    $[4] = pricing;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = hasPromotion && "text-status-success-text";
  let t4;
  if ($[6] !== currentClassName || $[7] !== t3) {
    t4 = cx(t3, currentClassName);
    $[6] = currentClassName;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== pricing) {
    t5 = formatDisplayPrice(pricing, formatCurrency);
    $[9] = pricing;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <span className={t4}>{t5}</span>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t6) {
    t7 = <span className={t1}>{t2}{t6}</span>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};